import { InjectionToken } from '@angular/core';

/**
 * Lo mínimo de `window.location` que necesita el redirect de subdominio.
 *
 * Existe para poder sustituirlo en tests: `window.location.replace()` no es
 * reasignable en los navegadores modernos, así que sin esta indirección el guard
 * navegaría de verdad y se llevaría por delante al runner de Karma.
 */
export interface LocationRef {
  readonly href: string;
  readonly origin: string;
  replace(url: string): void;
}

export const WINDOW_LOCATION = new InjectionToken<LocationRef>('WINDOW_LOCATION', {
  providedIn: 'root',
  factory: () => window.location,
});
